import { createContext } from 'react'
import moment from 'moment'
import { ChartDateBarContextType } from '../types'

export const ChartsDateBarContext = createContext<ChartDateBarContextType>({
  from: moment(),
  to: moment(),
  maxFrom: moment(),
  maxTo: moment(),
  setFrom: () => undefined,
  setTo: () => undefined,
  resolution: 'day',
  view: 'day',
  setView: () => undefined,
  isForecastEnabled: false,
  setIsForecastEnabled: () => undefined,
  hasCustomRange: false,
  setHasCustomRange: () => undefined,
  isChartDateBarSticky: false,
  setIsChartDateBarSticky: () => undefined,
  areSystemChartsVisible: true,
  setAreSystemChartsVisible: () => undefined,
  isCostSavingChartVisible: true,
  setIsCostSavingChartVisible: () => undefined,
})
